webpackJsonp([224494088270459],{

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EventDetail = exports.EventInvitation = exports.HowToApply = exports.Summary = exports.EventAttention = exports.EntertainerItem = exports.EntertainerWrapper = exports.MainVisualContainer = exports.ContentsWrapper = exports.InvitationWrapper = exports.QRHead = exports.QRFooter = exports.QRContainer = exports.QRCodeImage = exports.HowToApplyContainer = exports.ContentsContainer = exports.SummaryContainer = exports.MainVisual = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\nmax-height: 400px;\nmargin: 0 auto;\n'], ['\nmax-height: 400px;\nmargin: 0 auto;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-top: 2vw;\n  background: #ffffff;\n  padding: 2vw;\n  border-radius: 2.3vw;\n  display: flex;\n  flex-direction: column;\n  img {\n    object-fit: contain;\n    margin: 1vw auto;\n    max-height: 400px;\n  }\n  \n  p {\n    line-height: 2.4rem;\n  }\n  h2 {\n    margin-bottom: 1rem;\n    text-align: center;\n    img {\n      object-fit: contain;\n      margin: 0;\n      max-height: 100px;\n      height:11.8vw;\n    }\n  }\n\th3 {\n\t\tmargin-bottom: 1rem;\n    font-size: 3.0rem;\n\t\ttext-align: left;\n\t}\n'], ['\n  margin-top: 2vw;\n  background: #ffffff;\n  padding: 2vw;\n  border-radius: 2.3vw;\n  display: flex;\n  flex-direction: column;\n  img {\n    object-fit: contain;\n    margin: 1vw auto;\n    max-height: 400px;\n  }\n  \n  p {\n    line-height: 2.4rem;\n  }\n  h2 {\n    margin-bottom: 1rem;\n    text-align: center;\n    img {\n      object-fit: contain;\n      margin: 0;\n      max-height: 100px;\n      height:11.8vw;\n    }\n  }\n\th3 {\n\t\tmargin-bottom: 1rem;\n    font-size: 3.0rem;\n\t\ttext-align: left;\n\t}\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin-top: 0;\n  padding: 0;\n  background: transparent;\n'], ['\n  margin-top: 0;\n  padding: 0;\n  background: transparent;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\ndisplay: flex;\nflex-direction: column;\nalign-items: center;\nimg {\n  height: 8vw;\n  max-height: 60px;\n}\n\n'], ['\ndisplay: flex;\nflex-direction: column;\nalign-items: center;\nimg {\n  height: 8vw;\n  max-height: 60px;\n}\n\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  margin-top: 2vw;\n  margin-bottom: 2vw;\n'], ['\n  margin-top: 2vw;\n  margin-bottom: 2vw;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  margin-top: 2vw;\n  border-radius: 2.3vw;\n  display:flex;\n  flex-direction: column;\n  align-items: center;\n  background: #ffffff;\n  min-height: 200px;\n'], ['\n  margin-top: 2vw;\n  border-radius: 2.3vw;\n  display:flex;\n  flex-direction: column;\n  align-items: center;\n  background: #ffffff;\n  min-height: 200px;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  height: 200px;\n'], ['\n  height: 200px;\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  margin: 0;\n  width: 100%;\n  background-color: #9c0000;\n  border-radius: 2.3vw 2.3vw 0 0;\n  text-align: center;\n  padding: 1vw;\n  font-size: 2rem;\n  color: #ffffff;\n  line-height: 3rem;\n'], ['\n  margin: 0;\n  width: 100%;\n  background-color: #9c0000;\n  border-radius: 2.3vw 2.3vw 0 0;\n  text-align: center;\n  padding: 1vw;\n  font-size: 2rem;\n  color: #ffffff;\n  line-height: 3rem;\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  background: ', ';\n'], ['\n  background: ', ';\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  background: ', ';\n\n'], ['\n  background: ', ';\n\n']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n  display:flex;\n  flex-wrap: wrap;\n  justify-content: center;\n'], ['\n  display:flex;\n  flex-wrap: wrap;\n  justify-content: center;\n']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['\n  margin: 1%;\n  flex-basis: 48%;\n  text-align: center;\n  max-width: 300px;\n\n'], ['\n  margin: 1%;\n  flex-basis: 48%;\n  text-align: center;\n  max-width: 300px;\n\n']);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactImage = __webpack_require__(65);
	
	var _reactImage2 = _interopRequireDefault(_reactImage);
	
	var _reactHelmet = __webpack_require__(23);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHtmlParser = __webpack_require__(95);
	
	var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);
	
	var _layout = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var MainVisual = exports.MainVisual = (0, _styledComponents2.default)(_reactImage2.default)(_templateObject);
	
	var SummaryContainer = exports.SummaryContainer = _styledComponents2.default.div(_templateObject2);
	var ContentsContainer = exports.ContentsContainer = SummaryContainer.extend(_templateObject3);
	var HowToApplyContainer = exports.HowToApplyContainer = SummaryContainer.extend(_templateObject4);
	
	var QRCodeImage = exports.QRCodeImage = (0, _styledComponents2.default)(_reactImage2.default)(_templateObject5);
	
	var QRContainer = exports.QRContainer = _styledComponents2.default.div(_templateObject6);
	var QRFooter = exports.QRFooter = _styledComponents2.default.div(_templateObject7);
	
	var QRHead = exports.QRHead = _styledComponents2.default.h2(_templateObject8);
	
	var InvitationWrapper = exports.InvitationWrapper = _styledComponents2.default.div(_templateObject9, function (props) {
	  return props.background;
	});
	var ContentsWrapper = exports.ContentsWrapper = _styledComponents2.default.div(_templateObject9, function (props) {
	  return props.background;
	});
	
	var MainVisualContainer = exports.MainVisualContainer = _styledComponents2.default.div(_templateObject10, function (props) {
	  return props.background;
	});
	var EntertainerWrapper = exports.EntertainerWrapper = _styledComponents2.default.div(_templateObject11);
	var EntertainerItem = exports.EntertainerItem = _styledComponents2.default.div(_templateObject12);
	var EventAttention = exports.EventAttention = function EventAttention() {
	  return _react2.default.createElement(
	    SummaryContainer,
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      '\uFF08\u4F1A\u5834\u30FB\u30DB\u30FC\u30EB\u5185\u3000\u5165\u5834\u30FB\u30A4\u30D9\u30F3\u30C8\u306B\u3064\u3044\u3066\uFF09'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u516C\u6F14\u4E2D\u306E\u643A\u5E2F\u96FB\u8A71\u306F\u3001\u516C\u6F14\u306E\u59A8\u3052\u306B\u306A\u308B\u70BA\u3001\u307E\u305F\u53CA\u3073\u76D7\u64AE\u76D7\u8074\u884C\u70BA\u3092\u9632\u6B62\u3055\u305B\u3066\u9802\u304F\u305F\u3081\u30DB\u30FC\u30EB\u5185\u3067\u306E\u643A\u5E2F\u96FB\u8A71\u30FB\u30AB \u30E1\u30E9\u30FB\u9332\u97F3\u6A5F\u6750\u306E\u4F7F\u7528\u306F\u3054\u9060\u616E\u9858\u3044\u307E\u3059\u3002\u4E0D\u5BE9\u306A\u884C\u52D5\u3092\u767A\u898B\u3057\u305F\u3089\u78BA\u8A8D\u3055\u305B\u3066\u3044\u305F\u3060\u304F\u5834\u5408\u3082 \u3054\u3056\u3044\u307E\u3059\u306E\u3067\u3001\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u307E\u305B\u3002\u4E07\u304C\u4E00\u516C\u6F14\u4E2D\u306E\u643A\u5E2F\u96FB\u8A71\u306E\u4F7F\u7528\u304C\u5FC5\u8981\u3068\u306A\u3063\u305F\u5834\u5408\u306F\u3001 \u30DB\u30FC\u30EB\u5916\u306B\u3066\u304A\u9858\u3044\u7533\u3057\u4E0A\u3052\u307E\u3059\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u4E3B\u50AC\u5074\u306E\u8A8D\u3081\u305F\u30B9\u30BF\u30C3\u30D5\u4EE5\u5916\u306B\u3088\u308B\u64AE\u5F71\u30FB\u9332\u97F3\u306F\u53B3\u7981\u3068\u306A\u3063\u3066\u304A\u308A\u307E\u3059\u3002\u304A\u5BA2\u69D8\u306B\u3088\u308B\u643A\u5E2F\u96FB \u8A71\u3001\u30C7\u30B8\u30BF\u30EB\u30AB\u30E1\u30E9\u3001IC\u30EC\u30B3\u30FC\u30C0\u30FC\u7B49\u306B\u3088\u308B\u9332\u97F3\u30FB\u64AE\u5F71\u884C\u70BA\u306F\u767A\u898B\u3057\u6B21\u7B2C\u30C7\u30FC\u30BF\u30AF\u30EA\u30A2\u3068\u9000\u51FA\u3068\u3055\u305B\u3066\u9802\u304D\u307E\u3059\u306E\u3067\u3001\u3053\u3046\u3057\u305F\u884C\u70BA\u306F\u7D76\u5BFE\u306B\u884C\u308F\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u672C\u30A4\u30D9\u30F3\u30C8\u3067\u306F\u3001\u6765\u5834\u8005\u306E\u5B89\u5168\u78BA\u4FDD\u3092\u76EE\u7684\u306B\u6765\u5834\u8005\u624B\u8377\u7269\u691C\u67FB\u3092\u5B9F\u65BD\u3044\u305F\u3057\u307E\u3059\u3002\u6301\u8FBC\u7981\u6B62\u7269\uFF08\u4E0B\u8A18\u53C2\u7167\uFF09\u306E\u4F1A\u5834\u5185\u3078\u306E\u304A\u6301\u3061\u8FBC\u307F\u306F\u56FA\u304F\u304A\u65AD\u308A\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002\u4F1A\u5834\u5185\u306E\u5B89\u5168\u7BA1\u7406\u4E0A\u3001\u7686\u69D8\u306E\u3054\u7406\u89E3\u30FB\u3054\u5354\u529B\u3092\u304A\u9858\u3044\u3044\u305F\u3057\u307E\u3059\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\uFF08\u6301\u8FBC\u7981\u6B62\u7269\u306E\u4E00\u89A7\uFF09'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u9283\u5668\u30FB\u5200\u5263\u30FB\u5F13\u77E2\u30FB\u9396\u306A\u3069\u306E\u6B66\u5668\u30FB\u6B66\u5177\u985E'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u30E2\u30C7\u30EB\u30AC\u30F3\u30FB\u30A8\u30A2\u30AC\u30F3\u3001\u30CA\u30A4\u30D5\u3001\u30A2\u30A4\u30B9\u30D4\u30C3\u30AF\u30FB\u5343\u679A\u901A\u3057\u30FB\u91DD\u306A\u3069\u306E\u3068\u304C\u3063\u305F\u3082\u306E\u3001\u306F\u3055\u307F\u3001\u306A\u3069\u3002\u307E\u305F\u306F\u515C\u3084\u93A7\u7B49\u306E\u8863\u88F3\u306E\u88C5\u98FE\u54C1\u3082\u3001\u3068\u304C\u3063\u3066\u3044\u308B\u3082\u306E\u306F\u3053\u308C\u306B\u542B\u307F\u307E\u3059\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u6BD2\u7269\u30FB\u85AC\u7269\u30FB\u305D\u306E\u4ED6\u6709\u5BB3\u7269\u8CEA'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u71C3\u6599\u3001\u767A\u708E\u7B52\u3001\u82B1\u706B\u3001\u706B\u85AC\u3001\u591A\u91CF\u306E\u30E9\u30A4\u30BF\u30FC\u30FB\u30DE\u30C3\u30C1\u7B49\u306E\u53EF\u71C3\u7269\u3084\u53EF\u71C3\u6027\u306E\u9AD8\u3044\u3082\u306E'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u30CF\u30F3\u30DE\u30FC\u3001\u30C9\u30E9\u30A4\u30D0\u30FC\u7B49\u3001\u51F6\u5668\u3068\u3057\u3066\u4F7F\u7528\u3055\u308C\u308B\u6050\u308C\u306E\u3042\u308B\u3082\u306E'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u9152\u985E'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u30DA\u30C3\u30C8\u3001\u52D5\u7269\u985E\uFF08\u76F2\u5C0E\u72AC\u3001\u4ECB\u52A9\u72AC\u306F\u9664\u304F\uFF09'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u5468\u56F2\u306B\u5371\u5BB3\u3092\u52A0\u3048\u308B\u6050\u308C\u306E\u3042\u308B\u3082\u306E'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u81EA\u8EE2\u8ECA\u3001\u30ED\u30FC\u30E9\u30FC\u30B9\u30B1\u30FC\u30C8\u3001\u30B9\u30B1\u30FC\u30C8\u30DC\u30FC\u30C9'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u30E8\u30FC\u30E8\u30FC\u3001\u30DC\u30FC\u30EB\u3001\u5186\u76E4\u306A\u3069\u306E\u6295\u3052\u3089\u308C\u308B\u3082\u306E'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u305D\u306E\u4ED6\u3001\u30B9\u30BF\u30C3\u30D5\u304C\u5371\u967A\u3067\u3042\u308B\u3068\u5224\u65AD\u3057\u305F\u7269\u54C1'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u3000'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u30A4\u30D9\u30F3\u30C8\u3078\u306E\u518D\u5165\u5834\u306F\u57FA\u672C\u304A\u65AD\u308A\u3057\u3066\u304A\u308A\u307E\u3059\u3002\u3084\u3080\u3092\u5F97\u306A\u3044\u7406\u7531\u3067\u518D\u5165\u5834\u3092\u5E0C\u671B\u3055\u308C\u308B\u65B9\u306F\u3001\u5FC5\u305A\u8FD1\u304F\u306E\u30B9\u30BF\u30C3\u30D5\u307E\u3067\u304A\u58F0\u304C\u3051\u304F\u3060\u3055\u3044\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u5165\u5834\u8A3C\u7B49\u306E\u8EE2\u58F2\u884C\u70BA\u3001\u30B3\u30D4\u30FC\u3001\u507D\u9020\u306F\u56FA\u304F\u7981\u6B62\u3044\u305F\u3057\u307E\u3059\u3002\u7279\u306B\u507D\u9020\u884C\u70BA\u306F\u72AF\u7F6A\u306B\u5F53\u305F\u308A\u307E\u3059\u3002\u305D\u306E\u3088\u3046\u306A\u884C\u70BA\u3092\u898B\u3064\u3051\u6B21\u7B2C\u3001\u8B66\u5BDF\u306B\u901A\u5831\u3059\u308B\u3053\u3068\u3082\u3054\u3056\u3044\u307E\u3059\u306E\u3067\u3001\u3042\u3089\u304B\u3058\u3081\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u5165\u5834\u8A3C\u306F\u30A4\u30D9\u30F3\u30C8\u5F53\u65E5\u306E\u307F\u6709\u52B9\u3068\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u30A4\u30D9\u30F3\u30C8\u30B9\u30DA\u30FC\u30B9\u306B\u304A\u3051\u308B\u4ED6\u65B9\u306E\u5834\u6240\u53D6\u308A\u884C\u70BA\u306F\u7981\u6B62\u3068\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u98F2\u9152\u3001\u9152\u6C17\u5E2F\u3073\u306E\u65B9\u306F\u30A4\u30D9\u30F3\u30C8\u5165\u5834\u53CA\u3073\u7279\u5178\u4F1A\u3078\u306E\u53C2\u52A0\u306F\u3067\u304D\u307E\u305B\u3093\u306E\u3067\u3001\u3054\u4E86\u627F\u9858\u3044\u307E\u3059\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u5287\u5834\u5185\u3067\u306E\u98DF\u4E8B\u306F\u3054\u9060\u616E\u304F\u3060\u3055\u3044\u3002\u304A\u98F2\u7269\u306F\u3054\u81EA\u7531\u306B\u304A\u6301\u8FBC\u3044\u305F\u3060\u3051\u307E\u3059\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u4E2D\u5B66\u751F\u306F20\u6642\u307E\u3067\u3068\u306A\u308A\u307E\u3059\u306E\u3067\u3001\u6642\u9593\u306B\u3088\u308A\u30A4\u30D9\u30F3\u30C8\u306B\u53C2\u52A0\u51FA\u6765\u306A\u3044\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059\u3002(\u5C0F\u5B66\u751F\u4EE5\u4E0B\u5165\u5834\u4E0D\u53EF\uFF09'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u9AD8\u6821\u751F\u306F21\u6642\u307E\u3067\u3068\u306A\u308A\u307E\u3059\u306E\u3067\u3001\u6642\u9593\u306B\u3088\u308A\u30A4\u30D9\u30F3\u30C8\u306B\u53C2\u52A0\u51FA\u6765\u306A\u3044\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u4F53\u8ABF\u4E0D\u826F\u53CA\u3073\u598A\u5A66\u306E\u304A\u5BA2\u69D8\u306F\u53C2\u52A0\u306E\u6709\u7121\u3092\u78BA\u8A8D\u3044\u305F\u3057\u307E\u3059\u306E\u3067\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u4ED8\u6DFB\u3044\u304C\u5FC5\u8981\u306A\u8EAB\u4F53\u969C\u5BB3\u8005\u306E\u65B9\u306F\u4FC2\u54E1\u306B\u304A\u5C0B\u306D\u304F\u3060\u3055\u3044\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u5165\u5834\u8A3C\u306E\u7D1B\u5931\u3001\u76D7\u96E3\u7B49\u306B\u3088\u308B\u518D\u767A\u884C\u306F\u3044\u305F\u3057\u307E\u305B\u3093\u306E\u3067\u5FA1\u4E86\u627F\u304F\u3060\u3055\u3044\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u5929\u707D\u3001\u4EA4\u901A\u30B9\u30C8\u30E9\u30A4\u30AD\u306A\u3069\u4E0D\u53EF\u6297\u529B\u306E\u4E8B\u7531\u306B\u3088\u308A\u30A4\u30D9\u30F3\u30C8\u4E0D\u53EF\u80FD\u3068\u5224\u65AD\u3055\u308C\u305F\u5834\u5408\u306F\u3001\u30A4\u30D9\u30F3\u30C8\u3092\u4E2D\u6B62\u3044\u305F\u3057\u307E\u3059\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u30A4\u30D9\u30F3\u30C8\u5185\u5BB9\u306F\u30E1\u30F3\u30D0\u30FC\u306E\u72B6\u6CC1\u7B49\u306B\u3088\u308A\u5909\u66F4\u306B\u306A\u308B\u53EF\u80FD\u6027\u304C\u3054\u3056\u3044\u307E\u3059\u3002\u3042\u3089\u304B\u3058\u3081\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u30A4\u30D9\u30F3\u30C8\u4E2D\u6B62\u30FB\u5EF6\u671F\u306E\u5834\u5408\u3001\u65C5\u8CBB\u306A\u3069\u306E\u88DC\u511F\u306F\u3067\u304D\u307E\u305B\u3093\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u958B\u50AC\u65E5\u7A0B\u304A\u3088\u3073\u6642\u9593\u306B\u3064\u304D\u307E\u3057\u3066\u306F\u3001\u90FD\u5408\u306B\u3088\u308A\u5909\u66F4\u3068\u306A\u308B\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u672C\u30A4\u30D9\u30F3\u30C8\u306E\u5B89\u5168\u306A\u904B\u55B6\u306E\u70BA\u3001\u4E3B\u50AC\u8005\u5074\u304C\u30A4\u30D9\u30F3\u30C8\u306B\u53C2\u52A0\u3059\u308B\u306B\u3075\u3055\u308F\u3057\u304F\u306A\u3044\u3068\u5224\u65AD\u3057\u305F\u5834\u5408\u3001\u7279\u5B9A\u306E\u304A\u5BA2\u69D8\u306B\u3054\u53C2\u52A0\u3092\u304A\u65AD\u308A\u3059\u308B\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059\u3002\u3042\u3089\u304B\u3058\u3081\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u30A4\u30D9\u30F3\u30C8\u5F53\u65E5\u3001\u53D6\u6750\u7B49\u306B\u3088\u308A\u3001\u30AB\u30E1\u30E9\u304C\u5165\u308B\u53EF\u80FD\u6027\u304C\u3054\u3056\u3044\u307E\u3059\u3002\u304A\u5BA2\u69D8\u304C\u6620\u308A\u3053\u3080\u53EF\u80FD\u6027\u3082\u3054\u3056\u3044\u307E\u3059\u306E\u3067\u3001\u3042\u3089\u304B\u3058\u3081\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u30A4\u30D9\u30F3\u30C8\u4F1A\u5834\u3067\u306E\u8377\u7269\u3067\u306E\u5834\u6240\u53D6\u308A\u884C\u70BA\u306F\u7981\u6B62\u3044\u305F\u3057\u307E\u3059\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u30A4\u30D9\u30F3\u30C8\u524D\u65E5\u304B\u3089\u306E\u6CCA\u307E\u308A\u8FBC\u307F\u306F\u8FD1\u96A3\u306E\u3054\u8FF7\u60D1\u3068\u306A\u308A\u307E\u3059\u306E\u3067\u3001\u7981\u6B62\u3068\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u5217\u306E\u5272\u308A\u8FBC\u307F\u884C\u70BA\u3084\u4EF2\u9593\u3001\u53CB\u4EBA\u306B\u3088\u308B\u5217\u53D6\u308A\u884C\u70BA\u306F\u7981\u6B62\u3044\u305F\u3057\u307E\u3059\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u8377\u7269\u306B\u3088\u308B\u5217\u5834\u6240\u53D6\u308A\u884C\u70BA\u306F\u7981\u6B62\u3044\u305F\u3057\u307E\u3059\u3002'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u3000'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u226A\u4E0A\u8A18\u884C\u70BA\u304C\u767A\u899A\u3057\u305F\u5834\u5408\u306F\u30A4\u30D9\u30F3\u30C8\u3092\u4E2D\u6B62\u3059\u308B\u5834\u5408\u3082\u3054\u3056\u3044\u307E\u3059\u226B'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '--------------------------------------------------------------------------------'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '\u30A4\u30D9\u30F3\u30C8\u5185\u5BB9\u306F\u4E88\u544A\u7121\u304F\u5909\u66F4\u3055\u308C\u308B\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059\u3002\u3042\u3089\u304B\u3058\u3081\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002'
	    )
	  );
	};
	
	var Summary = exports.Summary = function Summary(props) {
	  var event = props.event;
	  if (event.html.summary) {
	    return _react2.default.createElement(
	      SummaryContainer,
	      null,
	      ' ',
	      event.html.summary.map(function (paragraph) {
	        return (0, _reactHtmlParser2.default)(paragraph);
	      }),
	      ' '
	    );
	  }
	};
	
	var HowToApply = exports.HowToApply = function HowToApply(props) {
	  var event = props.event;
	  if (event.enableApply) {
	    return _react2.default.createElement(
	      HowToApplyContainer,
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u53C2\u52A0\u65B9\u6CD5'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF11\uFF0EFlick!On!TV\u30A2\u30D7\u30EA\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\uFF08\u7121\u6599\uFF09'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: props.data.site.siteMetadata.firebaseDynamicLink },
	        _react2.default.createElement(_reactImage2.default, { src: "/event/img/download_button.png" })
	      ),
	      _react2.default.createElement(_reactImage2.default, { src: "/event/img/bottom_arrow.png" }),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF12\uFF0E\u4F1A\u54E1\u767B\u9332\uFF08\u53F3\u4E0A\u306E\u30A2\u30A4\u30B3\u30F3\u2192\u8A2D\u5B9A\u2192\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\uFF09'
	      ),
	      _react2.default.createElement(_reactImage2.default, { src: "/event/img/bottom_arrow.png" }),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF13\uFF0E\u4F1A\u54E1\u9650\u5B9A\u756A\u7D44\u89B3\u89A7\u3054\u62DB\u5F85\u306E\u304A\u77E5\u3089\u305B\u30D0\u30CA\u30FC\u3092\u30BF\u30C3\u30D7'
	      ),
	      _react2.default.createElement(_reactImage2.default, { src: "/event/img/bottom_arrow.png" }),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF14\uFF0E\u300C\u53C2\u52A0\u7533\u3057\u8FBC\u307F\u300D\u3092\u30BF\u30C3\u30D7'
	      ),
	      _react2.default.createElement(_reactImage2.default, { src: "/event/img/bottom_arrow.png" }),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\uFF15\uFF0E\u5F53\u65E5\u3001\u4F1A\u5834\u53D7\u3051\u4ED8\u3051\u3067QR\u30B3\u30FC\u30C9\u3092\u3054\u63D0\u793A\u304F\u3060\u3055\u3044'
	      )
	    );
	  } else {
	    return _react2.default.createElement(
	      HowToApplyContainer,
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u7533\u3057\u8A33\u3054\u3056\u3044\u307E\u305B\u3093\u3002\u3053\u306E\u30A4\u30D9\u30F3\u30C8\u306E\u52DF\u96C6\u306F\u7D42\u4E86\u3044\u305F\u3057\u307E\u3057\u305F\u3002'
	      )
	    );
	  }
	};
	
	var EventInvitation = exports.EventInvitation = function EventInvitation(_ref) {
	  var event = _ref.event;
	
	  return _react2.default.createElement(
	    InvitationWrapper,
	    { background: event.html.background },
	    _react2.default.createElement(_reactHelmet.Helmet, { title: event.title }),
	    event.html.contents.map(function (paragraph) {
	      return (0, _reactHtmlParser2.default)(paragraph);
	    }),
	    _react2.default.createElement(
	      _layout.FrameContainer,
	      null,
	      event.html.summary && _react2.default.createElement(
	        SummaryContainer,
	        null,
	        ' event.html.summary.map((paragraph) => (ReactHtmlParser(paragraph))) '
	      ),
	      _react2.default.createElement(
	        QRContainer,
	        null,
	        _react2.default.createElement(
	          QRHead,
	          null,
	          '\u53D7\u4ED8\u3067QR\u30B3\u30FC\u30C9\u3092\u3054\u63B2\u793A\u304F\u3060\u3055\u3044'
	        ),
	        _react2.default.createElement(QRCodeImage, { src: event.QRCodeUrl })
	      ),
	      _react2.default.createElement(QRFooter, null)
	    )
	  );
	};
	
	var EventDetail = function EventDetail(_ref2) {
	  var event = _ref2.event,
	      props = _objectWithoutProperties(_ref2, ['event']);
	
	  if (event.html) {
	    return _react2.default.createElement(
	      ContentsWrapper,
	      { background: event.html.background },
	      _react2.default.createElement(_reactHelmet.Helmet, { title: event.title }),
	      event.html.contents.map(function (paragraph) {
	        return (0, _reactHtmlParser2.default)(paragraph);
	      }),
	      _react2.default.createElement(
	        _layout.FrameContainer,
	        null,
	        event.html.summary && _react2.default.createElement(Summary, _extends({ event: event }, props)),
	        event.html.summary && _react2.default.createElement(HowToApply, _extends({ event: event }, props)),
	        _react2.default.createElement(EventAttention, null)
	      )
	    );
	  }
	  return _react2.default.createElement('div', null);
	};
	exports.EventDetail = EventDetail;

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(23);
	
	var _reactHtmlParser = __webpack_require__(95);
	
	var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactImage = __webpack_require__(65);
	
	var _reactImage2 = _interopRequireDefault(_reactImage);
	
	var _Event = __webpack_require__(192);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventPage = function (_Component) {
	  _inherits(EventPage, _Component);
	
	  function EventPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EventPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      event: {}
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  EventPage.prototype.componentDidMount = function componentDidMount() {
	    var event = this.props.pathContext.data;
	    this.setState({ event: event });
	  };
	
	  EventPage.prototype.render = function render() {
	    var event = this.state.event;
	    if (event && event.html) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactHelmet.Helmet, { title: event.title,
	          meta: [{ name: 'description', content: event.description }, { property: 'og:itle', content: event.title }, { property: 'og:description', content: event.description }]
	        }),
	        _react2.default.createElement(_Event.EventDetail, _extends({ event: event }, this.props))
	      );
	    } else {
	      return _react2.default.createElement('div', null);
	    }
	  };
	
	  return EventPage;
	}(_react.Component);
	
	EventPage.contextTypes = {
	  firebase: _propTypes2.default.object
	};
	exports.default = EventPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-event-js-845855c13d22855ac7b6.js